export const Types = {
  RESET_APP: 'app/RESET_APP',
};
